import { useMutation } from '@tanstack/react-query';

import { GroupPlayer } from '@/modules/league/new-components/types';

async function saveStatsReseed({ matchDateId }: { matchDateId: string }) {
  try {
    const response = await fetch(`/api/v1/leagues/rsvps/saveStatsReseedOnRSVP`, {
      method: 'POST',
      body: JSON.stringify({
        MatchDateID: matchDateId,
      }),
    });
    const responseData = await response.json();
    return responseData.data;
  } catch {
    /* empty */
  }
}

async function saveOptOutOfGroup({
  matchDateId,
  player,
}: {
  matchDateId: string;
  player: GroupPlayer;
}) {
  try {
    const response = await fetch(`/api/v1/leagues/groups/savePlayerOptOutOfGroup`, {
      method: 'POST',
      body: JSON.stringify({
        MatchDateID: matchDateId,
        UserID: player.UserID_1,
        SessionTeamID: player.SessionTeamID,
        PoolID: player.PoolID,
      }),
    });
    const responseData = await response.json();
    return responseData.data;
  } catch {
    /* empty */
  }
}

async function saveRemovePlayerOfGroup({
  matchDateId,
  player,
}: {
  matchDateId: string;
  player: GroupPlayer;
}) {
  try {
    const response = await fetch(`/api/v1/leagues/groups/saveRemovePlayerOfGroup`, {
      method: 'POST',
      body: JSON.stringify({
        MatchDateID: matchDateId,
        UserID: player.UserID_1,
        SessionTeamID: player.SessionTeamID,
        PoolID: player.PoolID,
      }),
    });
    const responseData = await response.json();
    return responseData.data;
  } catch {
    /* empty */
  }
}

async function saveGroupSplits({
  matchDateId,
  brakdown,
  poolTemplateId,
}: {
  matchDateId: string;
  brakdown: string;
  poolTemplateId: number;
}) {
  try {
    const response = await fetch(`/api/v1/leagues/groups/saveGroupSplits`, {
      method: 'POST',
      body: JSON.stringify({
        MatchDateID: matchDateId,
        GroupPlayerCountBreakdown: brakdown,
        PoolTemplateID: poolTemplateId,
      }),
    });
    const responseData = await response.json();
    return responseData.data;
  } catch {
    /* empty */
  }
}

async function saveGroupLineup({
  matchDateId,
  modifiedPlayers,
  countBreakdown,
}: {
  matchDateId: string;
  modifiedPlayers: {
    SessionTeamID: string;
    CurrentSeedNumber: number;
  }[];
  countBreakdown: string;
}) {
  try {
    const response = await fetch(`/api/v1/leagues/groups/saveGroupLineup`, {
      method: 'POST',
      body: JSON.stringify({
        MatchDateID: matchDateId,
        groupPlayers: modifiedPlayers,
        GroupPlayerCountBreakdown: countBreakdown,
      }),
    });
    const responseData = await response.json();
    return responseData.data;
  } catch {
    /* empty */
  }
}

async function saveGroupCourts({
  matchDateId,
  totalCourts,
  fullName,
}: {
  matchDateId: string;
  totalCourts: number;
  fullName: string;
}) {
  try {
    const response = await fetch(`/api/v1/leagues/groups/saveGroupCourts`, {
      method: 'POST',
      body: JSON.stringify({
        MatchDateID: matchDateId,
        TotalCourts: totalCourts,
        UpdatedByFullName: fullName,
      }),
    });
    const responseData = await response.json();
    return responseData.data;
  } catch {
    /* empty */
  }
}

export const useSaveStatsReseed = () => useMutation(saveStatsReseed);
export const useSaveOptOutOfGroup = () => useMutation(saveOptOutOfGroup);
export const useSaveRemoveOfGroup = () => useMutation(saveRemovePlayerOfGroup);
export const useSaveGroupSplits = () => useMutation(saveGroupSplits);
export const useSaveGroupLineup = () => useMutation(saveGroupLineup);
export const useSaveGroupCourts = () => useMutation(saveGroupCourts);
